/**
 * See https://www.notion.so/landr/16ca40de80e942f3a8f25f9e944dd70a?v=c3689c08477f42418abeced2159777fd
 */
var AuthEventIds = /*#__PURE__*/function (AuthEventIds) {
  AuthEventIds[AuthEventIds["TokenError"] = 38000] = "TokenError";
  AuthEventIds[AuthEventIds["ValidateCodeAndStateError"] = 38001] = "ValidateCodeAndStateError";
  AuthEventIds[AuthEventIds["RedirectError"] = 38002] = "RedirectError";
  AuthEventIds[AuthEventIds["ReconcileAuthUserFailed"] = 38003] = "ReconcileAuthUserFailed";
  AuthEventIds[AuthEventIds["AuthFetchProfileError"] = 38004] = "AuthFetchProfileError";
  AuthEventIds[AuthEventIds["SilentLoginError"] = 38005] = "SilentLoginError";
  AuthEventIds[AuthEventIds["SilentValidateError"] = 38006] = "SilentValidateError";
  AuthEventIds[AuthEventIds["InvalidHomePageError"] = 38007] = "InvalidHomePageError";
  AuthEventIds[AuthEventIds["AccessTokenRequestError"] = 38008] = "AccessTokenRequestError";
  AuthEventIds[AuthEventIds["AuthenticatedWithSuccess"] = 38009] = "AuthenticatedWithSuccess";
  AuthEventIds[AuthEventIds["TokenRefreshedWithSuccess"] = 38010] = "TokenRefreshedWithSuccess";
  AuthEventIds[AuthEventIds["StoreTransactionInvoked"] = 38011] = "StoreTransactionInvoked";
  AuthEventIds[AuthEventIds["RemoveTransactionInvoked"] = 38012] = "RemoveTransactionInvoked";
  AuthEventIds[AuthEventIds["SilentlyRefreshTokensInvoked"] = 38013] = "SilentlyRefreshTokensInvoked";
  AuthEventIds[AuthEventIds["SilentLogoutInvoked"] = 38014] = "SilentLogoutInvoked";
  AuthEventIds[AuthEventIds["AuthGetUserError"] = 38015] = "AuthGetUserError";
  return AuthEventIds;
}({});

export { AuthEventIds };
